import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

/* ----------------------------- SELECTED CARD TAB STORE ----------------------------- */
/* 
use for storing the selected tab name
*/

type SelectedCardTabState = {
  typeCard: string
}

type SelectedCardTabAction = {
  updateTypeCard: (type: string) => void
}

export const useSelectedCardTabStore = create<
  SelectedCardTabState & SelectedCardTabAction
>()(
  persist(
    (set) => ({
      typeCard: 'VIRTUAL',
      updateTypeCard: (type) => set(() => ({ typeCard: type }))
    }),
    {
      name: 'card-tab-id',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
